import { useState } from 'react';

export const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggle = () => setState((state) => !state);
  const setFalse = () => setState(false);
  const setTrue = () => setState(true);
  return [state, toggle, setFalse, setTrue] as const;
};
